import { call, put } from "redux-saga/effects";
import { setItems } from "../../slices/item/itemSlice";
import { goBack, push } from "connected-react-router";
import {
  requestGetAllItems,
  requestAddItem,
  requestEditItem,
  requestDeleteItem,
} from "../requests/item";

export function* handleAddItem(action) {
  try {
    yield call(requestAddItem(action));
    yield put(goBack());
  } catch (error) {
    console.log(error);
  }
}

export function* handleGetAllItems(action) {
  try {
    const response = yield call(requestGetAllItems);
    const { data } = response;
    yield put(setItems({ data }));
  } catch (error: any) {
    if (error.response.status) {
      yield put(setItems(null));
    }
  }
}

export function* handleSetItems(action) {
  try {
    yield put(setItems({ action }));
  } catch (error) {}
}

export function* handleEditItem(action) {
  try {
    yield call(requestEditItem(action));
    put(goBack());
  } catch (error) {
    console.log(error);
  }
}

export function* handleDeleteItem(action) {
  try {
    yield call(requestDeleteItem(action));
    yield put(push("/"));
  } catch (error) {}
}
